import type { AddressBookFormData } from '@/types/Models/AddressBook'
import type { AxiosResponse } from 'axios'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'
import Axios from '@/services/Axios'

export default class AddressBookProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'address-book'

  createSingle(data: AddressBookFormData): Promise<AxiosResponse> {
    return Axios.post(`/${this.endpoint}`, data)
  }

  import(file: File, companyId?: string | null) {
    const formData = new FormData()
    formData.append('file', file)
    if (companyId) {
      formData.append('company_id', companyId)
    }
    return this.submit('post', `/${this.endpoint}/import`, formData)
  }
}
